module.exports = __webpack_public_path__ + "static/media/2019-promo-1-cover.dfd2563c.jpg";